function normalizeEngagementId(engagementId: unknown): string | null {
  if (engagementId == null || engagementId === "") return null

  const parsed = Number(engagementId)
  if (!Number.isFinite(parsed) || parsed === 0) return null

  return String(parsed)
}

function claimDriverCancelHandling(
  handledEngagementIds: Set<string>,
  engagementId: unknown
): string | null {
  const key = normalizeEngagementId(engagementId)
  if (!key || handledEngagementIds.has(key)) return null

  handledEngagementIds.add(key)
  return key
}

function isActiveInTripState(currentState: string): boolean {
  return (
    currentState === "driver-found" ||
    currentState === "driver-arrived" ||
    currentState === "ride-started" ||
    currentState === "perfect-ride"
  )
}

export { claimDriverCancelHandling, isActiveInTripState, normalizeEngagementId }
